<app-page-title title="{{'Search' | translate}}" subTitle="{{q}}"></app-page-title>
<div class="container pt-5 pb-3 h-message">
	<div class="item text-center pb-4 position-message" *ngIf="result && result.data && result.data.length==0">
		<h4>{{'NoResult' | translate}}</h4>
	</div>
	<div class="item py-4" *ngFor="let item of result && result.data">
		<h4><a routerLink="{{getPathForType(item.type, item.attributes?.path?.alias,lang)}}">{{ item.attributes.title }}</a></h4>
		<div [innerHTML]="item.attributes.field_description.processed | noSanitize"></div>
	</div>
</div>